import { Location } from '@angular/common';
import { Component, HostListener, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { ArticleEnums } from 'src/app/enum/article-enums';
import { InventoryEnums } from 'src/app/enum/inventory-enums';
import { ArticleModel } from 'src/app/models/archive/article.model';
import { ArticleService } from 'src/app/services/archive/article.service';
import { WindowService } from 'src/app/services/authentication/window.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { TypeInventoryService } from 'src/app/services/global-services/type-inventory.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-register-article-generic',
  templateUrl: './register-article-generic.component.html',
  styleUrls: ['./register-article-generic.component.scss'],
  standalone: false
})
export class RegisterArticleGenericComponent implements OnInit {

  articleGenericContract: ArticleModel = new ArticleModel();
  articleGenericId: number = 0;
  disabledForm: boolean = false;
  formArticleGeneric: FormGroup = new FormGroup({});
  isOpened: string | undefined = undefined;
  listFamily: any[] = [];
  listGroup: any[] = [];
  listInventoryUnit: any[] = [];
  listRentalUnit: any[] = [];
  listSubgroup: any[] = [];
  listTypeArticle: any[] = [];
  listTypeInventory: any[] = [];
  nameWindow: string = 'Captura Artículos Genéricos';
  permissionUpdatable: boolean = false;
  projectName = ProjectName.projectName;
  severityState: string = 'success';
  stateArticle: string = '';
  titleState: string = '';
  url: string = 'article-generic';

  constructor(private activatedRoute: ActivatedRoute,
    private articleService: ArticleService,
    private confirmDialogService: ConfirmDialogService,
    private formBuilder: FormBuilder,
    private headerService: HeaderService,
    private location: Location,
    private title: Title,
    private toastHandlerService: ToastHandlerService,
    private typeInventoryService: TypeInventoryService,
    private windowService: WindowService) {
    this.validateForm(new ArticleModel());
  }

  async ngOnInit() {
    this.headerService.setTitle(this.nameWindow);
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    this.activatedRoute.params.subscribe(params => {
      this.articleGenericId = Object.keys(params).length > 0 ? params?.id : null;
    });
    await this.getPermission();
    this.handleInitialState();
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  ngOnDestroy() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }
  }

  async delete() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'error',
        `El usuario no tiene permisos para eliminar el artículo. Comuníquese con el administrador del sistema.`
      );
      return;
    }
    if (!this.articleGenericId || this.articleGenericId === 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear un artículo.'
      );
      return;
    }
    if ((await this.confirmDialogService.confirm('¿Realmente desea eliminar el artículo?'))) {
      try {
        await firstValueFrom(this.articleService.deleteArticle(this.articleGenericContract.articleId));
        this.createNewRegister();
        this.toastHandlerService.showToast(
          'success',
          'El artículo fue eliminado exitosamente.'
        );
      } catch (error) {
        console.error('Error al eliminar el artículo.', error);
      }
    }
  }

  async changeArticleGeneric(code: number) {
    if (code != null && code > 0) {
      await this.getArticleGenericByCode(code);
    } else {
      this.articleGenericId = 0;
      this.articleGenericContract = new ArticleModel();
      this.validateForm(this.articleGenericContract);
      this.toastHandlerService.showToast(
        'success',
        `El artículo ingresado NO existe. Para crear una nueva, presione el botón 'Nuevo'.`
      );
    }
  }

  changeTypeArticleId(typeArticleId: number) {
    const typeInventoryId = this.getTypeInventoryByArticleType(typeArticleId);
    this.formArticleGeneric.controls["typeInventoryId"].patchValue(typeInventoryId);
    const control = this.formArticleGeneric.controls['typeInventoryId'];
    typeInventoryId === InventoryEnums.otro ? control.enable() : control.disable();
  }

  async changeStateArticle() {
    const isActive = this.articleGenericContract.active;
    let messageState = '';
    if (!this.articleGenericId || this.articleGenericId === 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear un artículo.'
      );
      return;
    }
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'error',
        `El usuario no tiene permisos para cambiar el estado del artículo. Comuníquese con el administrador del sistema.`
      );
      return;
    }
    if (isActive) {
      this.titleState = "Inactivar";
      messageState = "¿Realmente desea inactivar el artículo?";
    } else {
      this.titleState = "Activar";
      messageState = "¿Realmente desea activar el artículo?";
    }
    if (await this.confirmDialogService.confirm(messageState)) {
      try {
        const response = await firstValueFrom(this.articleService.setActiveArticle(this.articleGenericContract.articleId));
        this.articleGenericContract = response;
        this.validateForm(this.articleGenericContract);
        if (response.active) {
          this.toastHandlerService.showToast(
            'success',
            'El artículo fue activado exitosamente.'
          );
        } else {
          this.toastHandlerService.showToast(
            'success',
            'El artículo fue inactivado exitosamente.'
          );
        }
      } catch (error) {
        console.error('Error al cambiar el estado del artículo.', error);
      }
    }
  }

  createNewRegister() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'warning',
        `El usuario no tiene permisos para crear artículos. Comuníquese con el administrador del sistema.`
      );
      return;
    }
    this.articleGenericId = 0;
    this.stateArticle = 'Activo';
    this.articleGenericContract = new ArticleModel();
    const rentalUnitId = this.listRentalUnit.find(item => item.label === 'Día')?.value ?? null;
    const inventoryUnitId = this.listInventoryUnit.find(item => item.label === 'Unidad')?.value ?? null;
    this.articleGenericContract.rentalUnitId = rentalUnitId;
    this.articleGenericContract.inventoryUnitId = inventoryUnitId;
    this.validateForm(this.articleGenericContract);
  }

  async getAllLists() {
    try {
      const [typeArticles, typeInventories, families, subgroups, groups, rentalUnits,
        inventoryUnits] = await Promise.all([
          firstValueFrom(this.articleService.getAllTypeArticlesForSelectAsync()),
          firstValueFrom(this.articleService.getAllTypeInventoriesForSelectAsync()),
          firstValueFrom(this.articleService.getAllFamiliesForSelectAsync()),
          firstValueFrom(this.articleService.getAllSubgroupsForSelectAsync()),
          firstValueFrom(this.articleService.getAllGroupsForSelectAsync()),
          firstValueFrom(this.articleService.getAllRentalUnitsForSelectAsync()),
          firstValueFrom(this.articleService.getAllInventoryUnitsForSelectAsync()),
        ]);
      this.listTypeArticle = typeArticles;
      this.listTypeInventory = typeInventories;
      this.listFamily = families;
      this.listSubgroup = subgroups;
      this.listGroup = groups;
      this.listRentalUnit = rentalUnits;
      this.listInventoryUnit = inventoryUnits;
      return true;
    } catch (error) {
      console.error('Error al obtener las listas.', error);
      return false;
    }
  }

  async getArticleGenericByCode(code: number) {
    try {
      const response = await firstValueFrom(this.articleService.getArticleByCode(code));
      this.articleGenericId = response.articleId;
      this.articleGenericContract = response;
      this.validateForm(this.articleGenericContract);
      this.location.replaceState(`/${this.url}/register/${this.articleGenericId}`);
    } catch (error) {
      this.articleGenericContract = new ArticleModel();
      this.articleGenericId = 0;
      this.validateForm(this.articleGenericContract);
      console.error('Error al obtener el artículo por código.', error);
    }
  }

  async getArticleGenericByName(name: string) {
    try {
      const response = await firstValueFrom(this.articleService.getArticleByName(name));
      if (!response) { return; }
      const confirmed = await this.confirmDialogService.confirm(`El artículo ${response.code} tiene el mismo nombre. ¿Desea continuar?`);
      if (!confirmed) {
        this.formArticleGeneric.controls['name'].patchValue(null);
      }
    } catch (error) {
      console.error('Error al obtener el artículo por nombre.', error);
    }
  }

  async getArticleGenericById() {
    try {
      const response = await firstValueFrom(this.articleService.getArticleById(this.articleGenericId));
      this.articleGenericContract = response;
      this.validateForm(this.articleGenericContract);
    } catch (error) {
      console.error('Error al obter el artículo por id.', error)
    }
  }

  getButtonClick(buttonClick: any) {
    const code = this.formArticleGeneric.get("code")?.value;
    this.handleOrderNavigation(buttonClick, code);
  }

  async getPermission() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast(
          'error',
          `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`
        );
      }
    } else {
      localStorage.clear();
    }
    await Promise.all([
      this.getAllLists(),
      this.getPermissionProfileByUrl()
    ]);
  }

  async getPermissionProfileByUrl() {
    try {
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
    } catch (error) {
      console.error('Error al buscar los permisos del perfil.', error);
    }
  }

  async getSubgroup(subgroupId: number | null) {
    const form = this.formArticleGeneric.controls;
    if (!subgroupId || subgroupId === 0) {
      form['subgroupId'].setValue(null);
      form['groupId'].setValue(null);
      return;
    }
    const subgroup = this.listSubgroup.find(x => x.value === subgroupId);
    if (subgroup) {
      form['groupId'].setValue(subgroup.groupId);
      form['subgroupId'].setValue(subgroupId);
    } else {
      form['groupId'].setValue(null);
      form['subgroupId'].setValue(null);
    }
  }

  getTypeInventoryByArticleType(selectedTypeArticleId: number): number {
    return this.typeInventoryService.getTypeInventory(selectedTypeArticleId);
  }

  async handleInitialState() {
    if (this.articleGenericId !== null && this.articleGenericId !== 0) {
      await this.getArticleGenericById();
    } else {
      this.createNewRegister();
    }
  }

  private async handleOrderNavigation(buttonClick: any, code: number) {
    const actionMap: Record<string, () => Promise<ArticleModel>> = {
      first: async () =>
        await firstValueFrom(this.articleService.getFirstArticleByKeysAsync(true)),
      next: async () =>
        await firstValueFrom(this.articleService.getNextArticleByKeysAsync(code, true)),
      previus: async () =>
        await firstValueFrom(this.articleService.getPreviusArticleByKeysAsync(code, true)),
      last: async () =>
        await firstValueFrom(this.articleService.getLastArticleByKeysAsync(true)),
    };
    const action = actionMap[buttonClick.target.id];
    if (!action) {
      this.articleGenericContract = new ArticleModel();
      this.validateForm(this.articleGenericContract);
      return;
    }
    try {
      const suspension = await action();
      this.articleGenericContract = suspension;
      this.articleGenericId = suspension.articleId;
      this.validateForm(this.articleGenericContract);
      this.location.replaceState(`/${this.url}/register/${this.articleGenericId}`);
    } catch (error) {
      this.articleGenericContract = new ArticleModel();
      this.validateForm(this.articleGenericContract);
      this.location.replaceState(`/${this.url}/register`);
      console.error(`Error al obtener el artículo (${buttonClick.target.id}).`, error);
    }
  }

  async send() {
    this.validateFormControls();
    if (!this.formArticleGeneric.valid) {
      this.showValidationMessages();
      return;
    }

    const modelArticleGeneric = this.formArticleGeneric.getRawValue() as ArticleModel;
    if (modelArticleGeneric.alterCode == "") modelArticleGeneric.alterCode = null;
    if (modelArticleGeneric.alterCode2 == "") modelArticleGeneric.alterCode2 = null;
    if (modelArticleGeneric.imageArticle == "") modelArticleGeneric.imageArticle = null;
    modelArticleGeneric.swGeneric = true;

    if (this.articleGenericId == 0) {
      try {
        const response = await firstValueFrom(this.articleService.createArticle(modelArticleGeneric));
        this.articleGenericId = response.articleId;
        this.articleGenericContract = response;
        this.validateForm(this.articleGenericContract);
        this.location.replaceState(`/${this.url}/register/${this.articleGenericId}`);
        this.toastHandlerService.showToast(
          'success',
          `El artículo fue creado exitosamente.`
        );
      } catch (error) {
        console.error('Error al crear el artículo.', error);
      }
      return;
    }

    if (await this.confirmDialogService.confirm('Al modificar este artículo generico, también se actualizarán todos los artículos dependientes asociados.')) {
      this.articleGenericContract.name = modelArticleGeneric.name;
      this.articleGenericContract.active = modelArticleGeneric.active;
      this.articleGenericContract.groupId = modelArticleGeneric.groupId;
      this.articleGenericContract.familyId = modelArticleGeneric.familyId;
      this.articleGenericContract.alterCode = modelArticleGeneric.alterCode;
      this.articleGenericContract.saleValue = modelArticleGeneric.saleValue;
      this.articleGenericContract.alterCode2 = modelArticleGeneric.alterCode2;
      this.articleGenericContract.subgroupId = modelArticleGeneric.subgroupId;
      this.articleGenericContract.imageArticle = modelArticleGeneric.imageArticle;
      this.articleGenericContract.rentalUnitId = modelArticleGeneric.rentalUnitId;
      this.articleGenericContract.typeArticleId = modelArticleGeneric.typeArticleId;
      this.articleGenericContract.typeInventoryId = modelArticleGeneric.typeInventoryId;
      this.articleGenericContract.inventoryUnitId = modelArticleGeneric.inventoryUnitId;
      this.articleGenericContract.replacementValue = modelArticleGeneric.replacementValue;

      try {
        const response = await firstValueFrom(this.articleService.updateArticle(this.articleGenericContract));
        this.articleGenericId = response.articleId;
        this.articleGenericContract = response;
        this.validateForm(this.articleGenericContract);
        this.toastHandlerService.showToast(
          'success',
          `El artículo fue modificado exitosamente.`
        );
      } catch (error) {
        console.error('Error al modificar el artículo.', error);
      }
    }
  }

  showValidationMessages(): void {
    const controlMessages: Record<string, Record<string, string>> = {
      code: {
        required: 'El campo Código es obligatorio.'
      },
      alterCode: {
        maxlength: 'El campo Código Alterno no puede tener más de 20 caracteres.'
      },
      alterCode2: {
        maxlength: 'El campo Código Alterno 2 no puede tener más de 20 caracteres.'
      },
      name: {
        required: 'El campo Nombre es obligatorio.',
        maxlength: 'El campo Nombre no puede tener más de 300 caracteres.'
      },
      familyId: {
        required: 'El campo Familia es obligatorio.',
        min: 'Debe seleccionar una Familia válida.'
      },
      groupId: {
        required: 'El campo Grupo es obligatorio.',
        min: 'Debe seleccionar un Grupo válido.'
      },
      subgroupId: {
        required: 'El campo Subgrupo es obligatorio.',
        min: 'Debe seleccionar un Subgrupo válido.'
      },
      typeArticleId: {
        required: 'El campo Tipo de Artículo es obligatorio.',
        min: 'Debe seleccionar un Tipo de Artículo válido.'
      },
      typeInventoryId: {
        required: 'El campo Tipo de Inventario es obligatorio.',
        min: 'Debe seleccionar un Tipo de Inventario válido.'
      },
      rentalUnitId: {
        required: 'El campo Unidad de Alquiler es obligatorio.',
        min: 'Debe seleccionar una Unidad de Alquiler válida.'
      },
      inventoryUnitId: {
        required: 'El campo Unidad de Inventario es obligatorio.',
        min: 'Debe seleccionar una Unidad de Inventario válida.'
      },
      active: {
        required: 'Debe indicar si el artículo está activo o inactivo.'
      },
      swGeneric: {
        required: 'Debe indicar si el artículo es genérico o no.'
      }
    };

    Object.keys(controlMessages).forEach(controlName => {
      const control = this.formArticleGeneric.get(controlName);
      if (control && control.invalid && control.errors) {
        const messages = controlMessages[controlName];
        Object.keys(control.errors).forEach(errorKey => {
          const message = messages[errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message);
          }
        });
      }
    });
  }

  updateFormState(isActive: boolean) {
    if (isActive) {
      this.disabledForm = false;
      this.titleState = 'Inactivar';
      this.severityState = 'success';
      this.stateArticle = 'Activo';
      setTimeout(() => this.formArticleGeneric.enable());
      const controlCode = this.formArticleGeneric.controls['code'];
      setTimeout(() => this.articleGenericContract.articleId != 0 ?
        controlCode.enable() : controlCode.disable());
      const controlTypeInventoryId = this.formArticleGeneric.controls['typeInventoryId'];
      setTimeout(() => this.articleGenericContract.typeArticleId !== ArticleEnums.tipoOtro ?
        controlTypeInventoryId.disable() : controlTypeInventoryId.enable());
    } else {
      this.disabledForm = true;
      this.titleState = 'Activar';
      this.severityState = 'danger';
      this.stateArticle = 'Inactivo';
      this.formArticleGeneric.disable();
      setTimeout(() => this.formArticleGeneric.controls['code'].enable());
    }
    setTimeout(() => this.formArticleGeneric.controls['groupId'].disable());
    if (!this.permissionUpdatable) {
      this.disabledForm = true;
      setTimeout(() => this.formArticleGeneric.disable());
    };
  }

  validateForm(articleGeneric: ArticleModel) {
    this.formArticleGeneric = this.formBuilder.group({
      code: [articleGeneric.code],
      alterCode: [articleGeneric.alterCode, [Validators.maxLength(20)]],
      alterCode2: [articleGeneric.alterCode2, [Validators.maxLength(20)]],
      name: [articleGeneric.name, [Validators.required, Validators.maxLength(300)]],
      familyId: [articleGeneric.familyId, [Validators.required, Validators.min(1)]],
      groupId: [articleGeneric.groupId, [Validators.required, Validators.min(1)]],
      subgroupId: [articleGeneric.subgroupId, [Validators.required, Validators.min(1)]],
      typeArticleId: [articleGeneric.typeArticleId, [Validators.required, Validators.min(1)]],
      typeInventoryId: [articleGeneric.typeInventoryId, [Validators.required, Validators.min(1)]],
      rentalUnitId: [articleGeneric.rentalUnitId, [Validators.required, Validators.min(1)]],
      inventoryUnitId: [articleGeneric.inventoryUnitId, [Validators.required, Validators.min(1)]],
      active: [articleGeneric.active, [Validators.required]],
      swGeneric: [articleGeneric.swGeneric, [Validators.required]],
      imageArticle: [articleGeneric.imageArticle],
      replacementValue: [articleGeneric.replacementValue, [Validators.required, Validators.min(0),
      Validators.max(99999999999.99)]],
      saleValue: [articleGeneric.saleValue, [Validators.required, Validators.min(0),
      Validators.max(99999999999.99)]],
      observation: [articleGeneric.observation, [Validators.maxLength(1000)]],
    });
    this.updateFormState(articleGeneric.active);
  }

  validateFormControls() {
    Object.keys(this.formArticleGeneric.controls).forEach((key) => {
      const control = this.formArticleGeneric.get(key);
      if (control && control.invalid) {
        console.warn(
          `${key} es inválido`,
          control.errors,
          'value:',
          control.value
        );
      }
    });
  }
}
